export const PRICING_CATEGORY_TYPE = {
  SCHOOL_AND_ACADEMICS: 'SCHOOL_AND_ACADEMICS',
  TEAM_SPORTS_WITH_NUMBERED_JERSEY: 'TEAM_SPORTS_WITH_NUMBERED_JERSEY',
  RACING: 'RACING',
  PERFORMANCE_AND_COMPETITION: 'PERFORMANCE_AND_COMPETITION',
  OTHER: 'OTHER',
};

export const PRICING_CATEGORY_TYPE_LABELS = {
  [PRICING_CATEGORY_TYPE.SCHOOL_AND_ACADEMICS]:
    'SCHOOL & ACADEMIC (FACIAL RECOGNITION)',
  [PRICING_CATEGORY_TYPE.TEAM_SPORTS_WITH_NUMBERED_JERSEY]:
    'TEAM SPORTS (FACIAL AND/OR NUMBERED JERSEY RECOGNITION)',
  [PRICING_CATEGORY_TYPE.RACING]: 'RACING (BIB & PLATE NUMBER RECOGNITION)',
  [PRICING_CATEGORY_TYPE.PERFORMANCE_AND_COMPETITION]:
    'PERFORMANCE & COMPETITION (FACIAL REC AND/OR TIME-BASED MATCHING)',
  [PRICING_CATEGORY_TYPE.OTHER]: 'OTHER SPORTS',
};

// Portrait-only galleries show a trimmed, re-grouped category list: the
// school group only holds the school portrait categories and the team sports
// group becomes "Team & Individual Portraits", which also takes in Other.
export const PORTRAIT_PRICING_CATEGORY_TYPE_LABELS = {
  ...PRICING_CATEGORY_TYPE_LABELS,
  [PRICING_CATEGORY_TYPE.SCHOOL_AND_ACADEMICS]: 'SCHOOL PORTRAITS',
  [PRICING_CATEGORY_TYPE.TEAM_SPORTS_WITH_NUMBERED_JERSEY]:
    'TEAM & INDIVIDUAL PORTRAITS',
};

// Action-only galleries only offer the school ceremonies and performances, not
// the school portrait categories.
export const ACTION_PRICING_CATEGORY_TYPE_LABELS = {
  ...PRICING_CATEGORY_TYPE_LABELS,
  [PRICING_CATEGORY_TYPE.SCHOOL_AND_ACADEMICS]:
    'SCHOOL CEREMONIES & PERFORMANCES (FACIAL RECOGNITION)',
};

// Categories offered as plain portrait categories under "Team & Individual
// Portraits" for portrait shoots, wherever they live for action shoots
// (School Ceremonies & Performances, Racing, Performance & Competition,
// Other). Matched by exact name, so a category added later must use one of
// these names to land in that group.
export const PORTRAIT_INDIVIDUAL_CATEGORY_NAMES = [
  'Track & Field',
  'Cross Country',
  'Dance',
  'Pageants',
  'Gymnastics',
  'Wrestling',
  'Cheer / Pom',
  'Swimming',
  'Band',
  'Badminton',
  'Water Polo',
  'Other',
];

// Categories hidden from portrait shoots: Dance is already offered as a
// portrait category, so its facial recognition only twin is action only.
export const ACTION_ONLY_CATEGORY_NAMES = ['Dance (FR Only)'];

// Ceremonies and performances are the only school categories shot as action
// photography; the two school portrait categories are portrait only.
export const ACTION_SCHOOL_CATEGORY_NAMES = [
  'Commencements',
  'Band',
  'Theater',
];
